import React from "react";

const NZDIcon: React.FC<{ size?: number }> = ({ size = 51 }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      shapeRendering="geometricPrecision"
      width={size}
      height={size}
      textRendering="geometricPrecision"
      imageRendering="optimizeQuality"
      fillRule="evenodd"
      clipRule="evenodd"
      viewBox="0 0 512 511.999"
    >
      <g fillRule="nonzero">
        <path
          fill="#4D4D4D"
          d="M256 0c70.684 0 134.689 28.664 181.012 74.987C483.336 121.311 512 185.316 512 256c0 70.683-28.664 134.688-74.988 181.012-46.323 46.323-110.328 74.987-181.012 74.987-70.676 0-134.689-28.664-181.013-74.987C28.664 390.688 0 326.676 0 256c0-70.684 28.664-134.689 74.987-181.013C121.311 28.664 185.316 0 256 0z"
        />
        <path
          fill="#fff"
          d="M256.001 19.596c65.278 0 124.382 26.466 167.162 69.243 42.776 42.779 69.242 101.884 69.242 167.162 0 65.277-26.466 124.382-69.245 167.159-42.777 42.779-101.881 69.245-167.159 69.245-65.278 0-124.382-26.466-167.162-69.243-42.776-42.779-69.243-101.884-69.243-167.161 0-65.278 26.467-124.383 69.243-167.162 42.78-42.777 101.884-69.243 167.162-69.243z"
        />
        <path
          fill="#012169"
          d="M256.001 39.594c119.517 0 216.407 96.886 216.407 216.407 0 119.517-96.89 216.406-216.407 216.406-119.521 0-216.407-96.889-216.407-216.406 0-119.521 96.886-216.407 216.407-216.407z"
        />
        <path
          fill="#fff"
          d="M62.187 159.658L95.1 143.194v48.249h52.773v-48.179l96.361 48.179h35.313v-17.76l-69.824-34.912 69.824-.003V86.002H209.44l70.205-35.116V40.884a218.722 218.722 0 00-23.644-1.29c-9.533 0-18.923.623-28.131 1.819l-79.997 40.013V68.508c-36.76 21.249-66.686 52.999-85.686 91.15z"
        />
        <path
          fill="#C8102E"
          d="M74.137 138.671h18.138l-25.878 12.951a216.439 216.439 0 017.74-12.951zm181.864-99.077c3.489 0 6.958.092 10.409.254l-92.304 46.154h-23.511l91.856-45.974a219.53 219.53 0 0113.55-.434zM81.379 128.176a217.708 217.708 0 0155.899-53.121v21.439h142.269v31.682H137.278v63.267h-31.683v-63.267H81.379zm198.266 63.267l-105.539-52.772h23.611l81.83 40.964v11.808h.098z"
        />
        <path
          fill="#fff"
          d="M399.764 147.687l15.009-10.929h-18.557l-5.76-17.66-5.756 17.66h-18.561l15.012 10.929-5.73 17.727 15.035-10.949 15.036 10.949z"
        />
        <path
          fill="#C7202F"
          d="M396.57 146.715l9.928-7.235H394.23l-3.774-11.703-3.773 11.703h-12.272l9.912 7.221-3.857 11.649 9.978-7.194 9.899 7.194z"
        />
        <path
          fill="#fff"
          d="M462.447 202.741l2.817-2.04c-.677-2.565-1.4-5.113-2.168-7.643h-3.805l-5.169-15.738-5.09 15.738H432.53l13.356 9.724-5.081 15.703 13.332-9.707 13.406 9.707-5.096-15.744z"
        />
        <path
          fill="#C7202F"
          d="M459.344 201.755l5.184-3.776-.62-2.196h-6.521l-3.265-9.789-3.182 9.789h-10.135l8.198 5.975-3.153 9.766 8.325-6.017 8.325 6.017z"
        />
        <path
          fill="#fff"
          d="M325.406 222.473l15.006-10.849h-18.528l-5.792-17.757-5.713 17.757h-18.604l15.068 10.897-5.784 17.656 15.033-10.946 15.035 10.946z"
        />
        <path
          fill="#C7202F"
          d="M322.238 221.535l9.999-7.286h-12.372l-3.773-11.708-3.773 11.708h-12.266l9.934 7.241-3.779 11.729 9.934-7.242 9.94 7.242z"
        />
        <path
          fill="#fff"
          d="M400.792 341.057l16.706-12.085h-20.639l-6.403-19.679-6.406 19.679h-20.636l16.704 12.083-6.412 19.699 16.75-12.195 16.748 12.195z"
        />
        <path
          fill="#C7202F"
          d="M397.6 340.083l11.626-8.39h-14.35l-4.42-13.721-4.496 13.721h-14.271l11.546 8.39-4.381 13.607 11.564-8.402 11.643 8.402z"
        />
      </g>
    </svg>
  );
};

export default NZDIcon;
